export default __webpack_public_path__ + "static/media/checkmark-circle-icon.126a1995.svg";